export default {
  access_token: '',
  deviceId: '',
  pushToken: '',
  account: {},
  usersMessages: null,
  isLoggedIn: false,
};
